import React, { useState } from 'react';
import AuditContainer from '../Components/AuditContainer';

const DefaultPage = () => {

    return (
        <AuditContainer />
    );
};

export default DefaultPage;
